import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import * as api from "../../lib/api";
import { toast } from "sonner";

export default function ScanRedirect() {
    const { tag } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        api.getInventoryItemByTag(tag)
            .then((r) => navigate(`/admin/inventory/${r.id}`, { replace: true }))
            .catch(() => {
                toast.error(`Aucun matériel trouvé pour "${tag}"`);
                navigate("/admin/inventory", { replace: true });
            });
    }, [tag, navigate]);

    return (
        <div className="page-container" data-testid="scan-redirect-page">
            <div className="animate-pulse text-gray-400">Recherche du matériel...</div>
        </div>
    );
}
